import { render, staticRenderFns } from "./terminatedEmployeeTable.vue?vue&type=template&id=39e022b1"
import script from "./terminatedEmployeeTable.vue?vue&type=script&lang=js"
export * from "./terminatedEmployeeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports